// 1st Party
import { showPopoverErrorsCallback } from './validation-methods';
import { refer } from './elements';

const referBoxValidatorOptions = {
    submitHandler: (form) => {
        form.submit();
    },

    rules: {
        'Referral.FirstName': {
            required: true
        },
        'Referral.LastName': {
            required: true
        },
        'Referral.PolicyNumber': {
            required: true
        },
        'Referral.Email': {
            customEmail: true
        }
    },

    onkeyup: function (element) {
        if ($(element).valid()) {
            $(element)
                .removeClass('is-invalid')
                .addClass('is-valid');
        }
    },

    showErrors: function (errorMap, errorList) {
        let boundShowPopoverErrorsCallback = showPopoverErrorsCallback.bind(this);
        return boundShowPopoverErrorsCallback(errorMap, errorList, 'top');
    }
};

refer.form.validate(referBoxValidatorOptions);